import Axios from 'axios'
import Servers from "../../server"
export default {
    state: {
        lineChartData: [],
        monthlyData:[],
        entries: 0,
        exits: 0,
        active: 0,
        entriesQr: 0,
        entriesMn: 0,
        entriesTotalQr: 0,
        entriesTotalMn: 0,
        assignedLicenses:0,
        recordedResident:0,
        recordedUsers:0,
        numberOfHouses: 0,
        numberOfHousesWithApp:0
    },
    getters: {
        getLineChart(state){
            return state.lineChartData
        },
        getEntries(state){
            return state.entries
        },
        getExits(state){
            return state.exits
        },
        getActive(state){
            return state.active;
        },
        getMonth(state){
            return state.monthlyData;
        },
        getEntriesQr(state){
            return state.entriesQr;
        },
        getEntriesManual(state){
            return state.entriesMn;
        },
        getEntriesTotalQr(state){
            return state.entriesTotalQr
        },
        getEntriesTotalMn(state){
            return state.entriesTotalMn
        },
        getAssignedLicenses(state){
            return state.assignedLicenses
        },
        getRecordedResident(state){
            return state.recordedResident
        },
        getRecordedUsers(state){
            return state.recordedUsers
        },
        getNumberOfHouses(state){
            return state.numberOfHouses
        },
        getNumberOfHousesWithApp(state){
            return state.numberOfHousesWithApp
        }
    },
    mutations: {
        setLineChartData(state, data){
            state.lineChartData = data
        },
        setEntries(state, data){
            state.entries = data
        },
        setExits(state, data){
            state.exits = data
        },
        setStatistics(state, data){
            state.entries = data.entryCount;
            state.exits = data.exitCount;
            state.active=data.activeCount;
            state.entriesQr=data.qrEntryCount;
            state.entriesMn = data.manualEntryCount;
        },
        setMonthlyData(state, data){
            state.monthlyData = data
        },
        setEntriesTotalQr(state, data){
            state.entriesTotalQr = data
        },
        setEntriesTotalMn(state, data){
            state.entriesTotalMn = data;
        },
        setEntriesQr(state,data){
            state.entriesQr=data;
        },
        setEntriesManual(state,data){
            state.entriesMn=data;
        },
        setActive(state,data){
            state.active = data;
        },
        setResidentSummary(state, data){
            state.assignedLicenses = data.assignedLicenses
            state.recordedResident = data.recordedResidents
            state.recordedUsers = data.recordedUsers
            state.numberOfHouses = data.numberOfHouses
            state.numberOfHousesWithApp = data.numberOfHousesWithApplication
        }
    },
    actions: {
        async dailyVisits(context){
            var response = await Axios.get(Servers.serverApi+"api/visitantDashBoard/dailyVisits/", {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
               }
              });
              context.commit('setStatistics', response.data.data)
        },
        async monthlyVisits(context){
            var response = await Axios.get(Servers.serverApi+"api/visitantDashBoard/monthlyVisits/", {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
               }
              });
              context.commit('setMonthlyData', response.data.data)
        },
        async EntriesTotalQr(context) {
          
              var response = await Axios.get(Servers.serverApi+"api/visitants/entriesQR/", {
              responseType: "application/json",
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token")
             }
            });
            context.commit("setEntriesTotalQr", response.data)
       
  
          },
          async EntriesTotalManual(context) {
           
             var response= await Axios.get(Servers.serverApi+"api/visitants/entriesManual/", {
              responseType: "application/json",
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token")
             }
            })
            context.commit("setEntriesTotalMn", response.data)
          },
          async residentSummary(context){
              let response = await Axios.get(Servers.serverApi + "api/visitantDashBoard/residentSummary", {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                }
              })
              console.log(response.data)
              context.commit("setResidentSummary", response.data.data)
              
          }
    }


}